import React, { useState } from "react";
import backLinkgetCall from "../../Apis/backlink/Get";
import { getAPIUrlBM } from "../../utils/config";
import LimitsContext from "./LimitsContext";

function LimitState({ children }) {
  const [totalBackLinks, setTotalBackLinks] = useState(0);
  const [bklCrawledPerMonth, setbklCrawledPerMonth] = useState(0);
  const [totalbklCrawled, setTotalbklCrawled] = useState(0);
  const [totalDomainsDeleted, setTotalDomainsDeleted] = useState(0);
  const [domainCount, setDomainCount] = useState(0);
  const setBackLinkLimits = (backLinkLimits) => {
    // console.log(backLinkLimits);
    setTotalBackLinks(backLinkLimits["POST/createlink"] || 0);
    setbklCrawledPerMonth(backLinkLimits["POST/Monitorings"] || 0);
    setTotalbklCrawled(backLinkLimits["POST/TotalMonitorings"] || 0);
    setTotalDomainsDeleted(backLinkLimits["POST/deleteDomain"] || 0);
  };

  const getDomainCount = async () => {
    const url = getAPIUrlBM();
    const res = await backLinkgetCall(url + "/countDomain");
    setDomainCount(res.count[0].count);
  };

  return (
    <LimitsContext.Provider
      value={{
        totalBackLinks,
        bklCrawledPerMonth,
        totalbklCrawled,
        totalDomainsDeleted,
        setBackLinkLimits,
        getDomainCount,
        domainCount,
      }}
    >
      {children}
    </LimitsContext.Provider>
  );
}

export default LimitState;
